import React, { Component } from 'react';
import { connect } from 'react-redux';
import numeral from 'numeral';
import TaskDetails from './TaskDetails';
import { Clearfix, Col } from 'react-bootstrap';
import TaskStatus from 'components/shared/task-status/TaskStatus';
import { usersUtil, TYPES } from 'services/utils/users-util';
import { PermissionsUtil } from 'services/utils/permissions-util';
import Date from 'components/shared/text/Date';
import {
  approveTaskWorkRequest,
  cancelTask,
  completeTask,
  deleteTaskRequest,
  editTask,
  loadSubTradesRequest,
  markItemTaskChecklistRequest,
  removeCompleteTaskImagesRequest,
  removeImageRequest,
  setSelectedOpenItem,
  startTask,
  taskChangeRequest,
  updateTaskRequest,
  uploadCompleteTaskImagesRequest,
  withdrawQuoteRequest,
  addTaskNoteRequest,
  loadTaskNotesRequest,
} from 'actions/admin/work-orders/details/details';
import {
  getCurrentTask,
  getEditTask,
  getOpenItemsByTaskId,
  getPreExistingConditions,
  getProposals,
  getQuotes,
  getQuotesSelectedByTaskId,
  getSelectedOpenItemId,
  getTaskNotes,
} from 'selectors/admin/work-orders/details/details';
import CreateQuoteModal from './quotes/CreateQuoteModal';
import QuotesRequestModal from './quotes/QuotesRequestModal';
import { showQuotesRequestModalRequest } from 'actions/admin/work-orders/details/quotes-request';
import {
  showCreateQuoteModal,
  showReviewQuoteModal,
} from 'actions/admin/work-orders/details/create-quote';
import DenyQuoteModal from './quotes/DenyQuoteModal';
import { showDenyQuoteModal } from 'actions/admin/work-orders/details/deny-quote';
import './DetailsTasks.css';
import {
  getCurrentWorkOrder,
  getSubTradesByTradeId,
  getTasks,
  getTrades,
} from 'selectors/admin/work-orders/work-orders';
import {
  goToWorkOrder,
  markCurrentWorkOrderAsComplete,
} from 'actions/admin/work-orders/work-orders';
import OpenItemsViewer from './OpenItemsViewer';
import { TaskStatusEnum, TaskStatusKeys } from 'domain/task-status-enum';
import { setShowAddOpenItemModalRequest } from 'actions/admin/work-orders/details/open-items';
import AddOpenItemModal from './open-items/AddOpenItemModal';
import EditOpenItemModal from './open-items/EditOpenItemModal';
import { WorkOrderStatusEnum } from 'services/utils/work-order-status-enum';
import MessageModal from 'components/shared/modal/MessageModal';
import Chat from 'components/shared/chat/Chat';
import { simpleScrollTo } from 'services/utils/scroller-util';
import faArrowDown from '@fortawesome/fontawesome-free-solid/faArrowDown';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import TasksChecklist from './TasksChecklist';
import ImageUpload from 'components/shared/image-upload/ImageUpload';
import DetailsTaskButtons from './tasks/DetailsTaskButtons';
import { showDetailsTaskButtons } from 'services/utils/details-task-util';
import TasksTable from 'components/admin/work-orders/details/tasks/TasksTable';
import DetailsTaskPreExistingConditions from 'components/admin/work-orders/details/tasks/DetailsTaskPreExistingConditions';
import Button from 'components/shared/button/Button';
import {
  setShowChangeOrderTaskModal,
  deleteChangeOrderTask,
} from 'components/admin/work-orders/details/change-order-tasks/store/actions';
import { getChangeOrderTasks } from 'components/admin/work-orders/details/change-order-tasks/store/selectors';
import ChangeOrderTask from 'components/admin/work-orders/details/change-order-tasks/ChangeOrderTask';
import ChangeOrderTaskModal from 'components/admin/work-orders/details/change-order-tasks/ChangeOrderTaskModal';
import {
  setShowChangeOrderQuoteModal,
  withdrawChangeOrderQuote,
  withdrawChangeOrderQuoteRequest,
} from 'components/admin/work-orders/details/change-order-quotes/store/actions';

class DetailsTasks extends Component {
  constructor(props) {
    super(props);
    this.userIsAdmin =
      usersUtil.isAdmin(this.props.user) ||
      usersUtil.hasType(this.props.user, TYPES.GENERAL_CONTRACTOR);
    this.contractorUserCanSeeMoney = PermissionsUtil.contractorUserCanSeeMoney(
      this.props.user
    );

    this.state = {
      showApprovedModal: false,
      showCompleteModal: false,
      showDeleteConfirmation: false,
      showDeleteCoConfirmation: false,
      showWithdrawConfirmation: false,
      showWithdrawCoQuoteConfirmation: false,
      showWithdrawCoQuoteRequestConfirmation: false,
    };
  }

  userIsContractor = () => {
    const { user, currentTask } = this.props;
    return (
      usersUtil.hasType(user, TYPES.CONTRACTOR) ||
      (this.userIsAdmin && currentTask && !currentTask.awardedContractor)
    );
  };

  render() {
    const contractorUserCanSeeMoney = this.contractorUserCanSeeMoney;
    this.currentTask = null;
    if (this.props.currentTask !== null && this.props.tasks.length > 0) {
      // This variable contains the current task with the backend data (this.props.currentTask has fewer data)
      this.currentTask = this.props.tasks.find(
        (task) => task.id === this.props.currentTask.id
      );
      this.changeOrderTask = this.props.changeOrderTasks.find(
        (cot) => cot.task_id === this.currentTask.id && cot.status === 'pending'
      );
    }

    return (
      this.props.currentWorkOrder !== null && (
        <div className="details-tasks">
          {this.props.currentTask !== null && this.currentTask !== null && (
            <div className="task-details-container">
              <Col md={8}>
                {this.showBidDueDate() && (
                  <div className="due-date-container">
                    <span className="body-regular">Bid due date</span>
                    <span className="body-bold-orange">
                      <Date value={this.props.currentTask.bidDueDate} />
                    </span>
                  </div>
                )}

                {this.showNotes() && (
                  <div
                    className="notes-count-container"
                    onClick={this.handleNotesClick}
                  >
                    <span>Task Chat ({this.props.taskNotes.length}) </span>
                    <FontAwesomeIcon icon={faArrowDown} />
                  </div>
                )}

                <TaskDetails
                  minMaxImages={{
                    min: 3,
                    max: 6,
                  }}
                  readOnly={!this.props.editTask}
                  subTradesByTradeId={this.props.subTradesByTradeId}
                  task={this.props.currentTask}
                  trades={this.props.trades}
                  onChange={this.handleTaskChange}
                  onCancel={this.handleTaskCancel}
                  onNotesClick={this.handleNotesClick}
                  onSubmit={this.handleTaskSubmit}
                  onTaskImageRemove={
                    this.props.editTask ? this.handleTaskImageRemove : undefined
                  }
                />

                {this.props.changeOrderTasks
                  .filter(
                    (cot) =>
                      cot.task_id === this.currentTask.id &&
                      (cot.status === 'approved' || cot.status === 'acr')
                  )
                  .sort((cot1, cot2) => cot1.number - cot2.number)
                  .map(function (cot) {
                    return (
                      <ChangeOrderTask
                        key={cot.id}
                        changeOrderTask={cot}
                        showEstimateInTitle={contractorUserCanSeeMoney}
                      />
                    );
                  })}

                {this.showChangeOrderTask(this.changeOrderTask) ? (
                  <ChangeOrderTask
                    changeOrderTask={this.changeOrderTask}
                    showEstimateInTitle={contractorUserCanSeeMoney}
                    showRequestQuoteBtn={
                      this.userIsAdmin &&
                      !this.changeOrderTask.change_order_quote
                    }
                    showSubmitQuoteBtn={this.showSubmitCoQuoteBtn(
                      this.changeOrderTask
                    )}
                    showDeleteCoBtn={
                      this.userIsAdmin &&
                      !this.changeOrderTask.change_order_quote
                    }
                    showWithdrawQuoteBtn={this.showWithdrawCoQuoteBtn(
                      this.changeOrderTask
                    )}
                    showWithdrawCoQuoteRequestBtn={this.showWithdrawCoQuoteRequestBtn(
                      this.changeOrderTask
                    )}
                    onDeleteCoClick={this.handleDeleteCo}
                    onQuoteActionClick={() =>
                      this.props.dispatch(setShowChangeOrderQuoteModal())
                    }
                    onWithdrawQuoteClick={() => this.handleWithdrawCoQuote()}
                    onWithdrawCoQuoteRequestClick={() =>
                      this.handleWithdrawCoQuoteRequest()
                    }
                    onEditActionClick={() =>
                      this.props.dispatch(setShowChangeOrderTaskModal())
                    }
                  />
                ) : (
                  this.showCreateChangeOrder() && (
                    <div>
                      <Button
                        className="button-orange create-change-order-btn"
                        label="Create Change Order"
                        onClick={() =>
                          this.props.dispatch(setShowChangeOrderTaskModal())
                        }
                      />
                      <ChangeOrderTaskModal />
                    </div>
                  )
                )}

                {
                  /*** Task Checklist ************/
                  (this.props.currentTask.status === TaskStatusKeys.PRE ||
                    this.props.currentTask.status === TaskStatusKeys.WIP ||
                    this.props.currentTask.status === TaskStatusKeys.CMP ||
                    this.props.currentTask.status === TaskStatusKeys.CLS) &&
                    this.renderTaskChecklist()
                }

                <DetailsTaskPreExistingConditions />

                {
                  /*** Completed work - Contractor in task WIP ************/
                  this.userIsContractor() &&
                    this.props.currentTask.status === TaskStatusKeys.WIP &&
                    this.currentTask.task_checklist !== undefined &&
                    this.currentTask.task_checklist !== null && (
                      <div className="completed-work-container">
                        <span className="h3">Completed work images</span>
                        <ImageUpload
                          extensions={['.jpg', '.jpeg', '.gif', '.png']}
                          images={this.currentTask.task_checklist.completed_images.map(
                            (image) => {
                              return {
                                preview: image.image.preview.url,
                              };
                            }
                          )}
                          notes="Provide photos of the completed work"
                          onRemove={this.handleCompleteTaskImageRemove.bind(
                            this,
                            this.currentTask.task_checklist.completed_images,
                            this.currentTask.task_checklist.id
                          )}
                          onUpload={this.handleCompleteTaskImageUpload.bind(
                            this,
                            this.currentTask.task_checklist.id
                          )}
                        />
                      </div>
                    )
                }
                {
                  /*** Completed work - Contractor in task CMP and Admin WIP and afterwards ************/
                  this.currentTask.task_checklist !== undefined &&
                    this.currentTask.task_checklist !== null &&
                    this.currentTask.task_checklist.completed_images.length >
                      0 &&
                    ((!this.userIsContractor() &&
                      this.props.currentTask.status === TaskStatusKeys.WIP) ||
                      this.props.currentTask.status === TaskStatusKeys.CMP ||
                      this.props.currentTask.status === TaskStatusKeys.CLS) && (
                      <div className="completed-work-container">
                        <span className="h3">Completed work images</span>
                        <ImageUpload
                          extensions={['.jpg', '.jpeg', '.gif', '.png']}
                          images={this.currentTask.task_checklist.completed_images.map(
                            (image) => {
                              return {
                                preview: image.image.preview.url,
                                url: image.image.url,
                              };
                            }
                          )}
                          readOnly={true}
                        />
                      </div>
                    )
                }

                {!this.props.editTask && (
                  <div className="dt-bottom-button-container">
                    {this.renderTasksButtons()}
                    {this.showBidDueDate() && (
                      <div className="due-date-container due-date-bottom-container">
                        <span className="body-regular">Bid due date</span>
                        <span className="body-bold-orange">
                          <Date value={this.props.currentTask.bidDueDate} />
                        </span>
                      </div>
                    )}
                  </div>
                )}

                {this.showNotes() && (
                  <div className="task-notes-container">
                    <div>Task Chat</div>
                    <Chat
                      notes={this.props.taskNotes}
                      loadChat={this.handleLoadNotes}
                      handleSubmit={this.handleAddNote}
                    />
                  </div>
                )}
              </Col>
              <Col md={4}>
                <TaskStatus status={this.props.currentTask.status} />
                {this.showOpenItems() && this.props.openItemsByTaskId !== null && (
                  <div className="open-items-container">
                    <OpenItemsViewer
                      items={
                        this.props.openItemsByTaskId[
                          this.props.currentTask.id
                        ] !== undefined
                          ? this.props.openItemsByTaskId[
                              this.props.currentTask.id
                            ].map((openItem) => {
                              return {
                                id: openItem.id,
                                critical: openItem.critical,
                                description: openItem.description,
                                dueDate: openItem.due_date,
                                letter: openItem.letter,
                                resolvedNote: openItem.resolved_note,
                                status: openItem.resolved
                                  ? 'complete'
                                  : 'incomplete',
                                updatedAt: openItem.updated_at,
                              };
                            })
                          : []
                      }
                      onAddOpenItem={this.handleAddOpenItem}
                      onSelectOpenItem={this.handleSelectOpenItem}
                    />
                  </div>
                )}
              </Col>
              <Clearfix />

              {this.showOpenItems() && <AddOpenItemModal />}
              {this.showOpenItems() &&
                this.props.selectedOpenItemId !== null && (
                  <EditOpenItemModal
                    taskId={this.props.currentTask.id}
                    taskNumber={this.props.currentTask.number}
                  />
                )}

              <QuotesRequestModal />
              <CreateQuoteModal />
              <DenyQuoteModal />

              <MessageModal
                show={this.state.showCompleteModal}
                message={
                  'Thank you for completing the task. You will be able to upload your invoice once all of your tasks are complete.'
                }
                onHide={this.handleCloseCompleteModal}
              />

              <MessageModal
                show={this.state.showApprovedModal}
                message={`Thank you. Task #${numeral(
                  this.props.currentTask.number
                ).format('00')} is now approved.`}
                onHide={this.handleCloseApprovedModal}
              />

              <ConfirmationModal
                show={this.state.showDeleteCoConfirmation}
                message="Are you sure you want to delete the change order?"
                onHide={this.handleDeleteCoConfirmation}
              />

              <ConfirmationModal
                show={this.state.showWithdrawConfirmation}
                message="Are you sure you want to withdraw the quote?"
                onHide={this.handleWithdrawConfirmation}
              />

              <ConfirmationModal
                show={this.state.showWithdrawCoQuoteConfirmation}
                message="Are you sure you want to withdraw the change order pricing?"
                onHide={this.handleWithdrawCoQuoteConfirmation}
              />

              <ConfirmationModal
                show={this.state.showWithdrawCoQuoteRequestConfirmation}
                message="Are you sure you want to withdraw the change order quote request?"
                onHide={this.handleWithdrawCoQuoteRequestConfirmation}
              />

              <ConfirmationModal
                show={this.state.showDeleteConfirmation}
                message="Are you sure you want to delete the task?"
                onHide={this.handleDeleteConfirmation}
              />
            </div>
          )}

          {this.props.currentTask === null && <TasksTable />}
        </div>
      )
    );
  }

  renderTasksButtons() {
    const buttonsActive = showDetailsTaskButtons(
      this.props.user,
      this.currentTask,
      this.findQuoteForCurrentTask(),
      this.props.preExistingConditions
    );
    return (
      <DetailsTaskButtons
        {...buttonsActive}
        onRequestBids={this.handleBidsRequest}
        onTaskEdit={this.handleTaskEdit}
        onTaskDelete={this.handleTaskDelete}
        onCreateQuote={this.handleCreateQuote}
        onDenyQuote={this.handleDenyQuote}
        onWithdrawQuote={this.handleWithdrawQuote}
        onViewCounterQuote={this.handleViewCounterQuote}
        onResubmitQuote={this.handleResubmitQuote}
        onStartTask={this.handleStartTask}
        onMarkAsComplete={this.handleCompleteTask}
        onApproveWork={this.handleApproveWork}
        task={{
          number: this.currentTask.number,
          name: this.currentTask.name,
        }}
        workOrder={{
          name: this.props.currentWorkOrder.name,
          number: this.props.currentWorkOrder.number,
        }}
      />
    );
  }

  showBidDueDate() {
    return (
      this.props.currentTask !== null &&
      this.props.currentTask.bidDueDate !== null &&
      (TaskStatusEnum.RFP.equals(this.props.currentTask.status) ||
        TaskStatusEnum.AGG.equals(this.props.currentTask.status))
    );
  }

  showChangeOrderTask(changeOrderTask) {
    return (
      changeOrderTask &&
      (this.userIsAdmin || changeOrderTask.change_order_quote)
    );
  }

  showSubmitCoQuoteBtn(changeOrderTask) {
    const coQuote = changeOrderTask.change_order_quote;
    return (
      this.userIsContractor() &&
      coQuote &&
      (coQuote.status === 'waiting' || coQuote.status === 'withdrawn')
    );
  }

  showWithdrawCoQuoteBtn(changeOrderTask) {
    const coQuote = changeOrderTask.change_order_quote;
    return this.userIsContractor() && coQuote && coQuote.status === 'received';
  }

  showWithdrawCoQuoteRequestBtn(changeOrderTask) {
    const coQuote = changeOrderTask.change_order_quote;
    return (
      this.userIsAdmin &&
      !!changeOrderTask.change_order_quote &&
      coQuote.status !== 'approved' &&
      coQuote.status !== 'received'
    );
  }

  showCreateChangeOrder() {
    return (
      (TaskStatusEnum.PRE.equals(this.props.currentTask.status) ||
        TaskStatusEnum.WIP.equals(this.props.currentTask.status) ||
        TaskStatusEnum.CMP.equals(this.props.currentTask.status)) &&
      this.userIsAdmin
    );
  }

  showNotes() {
    return (
      (TaskStatusEnum.PRE.equals(this.props.currentTask.status) ||
        TaskStatusEnum.WIP.equals(this.props.currentTask.status) ||
        TaskStatusEnum.CMP.equals(this.props.currentTask.status)) &&
      (this.userIsAdmin || this.userIsContractor())
    );
  }

  showOpenItems() {
    const statusEnum = WorkOrderStatusEnum.create(
      this.props.currentWorkOrder.status
    );
    return (
      (WorkOrderStatusEnum.IN_PROGRESS.equals(statusEnum) ||
        WorkOrderStatusEnum.COMPLETE.equals(statusEnum) ||
        WorkOrderStatusEnum.CLOSED.equals(statusEnum)) &&
      (this.userIsAdmin || this.userIsContractor())
    );
  }

  handleCloseCompleteModal = () => {
    this.setState({
      showCompleteModal: false,
    });
    this.props.dispatch(goToWorkOrder(this.props.currentWorkOrder.id));
  };

  renderTaskChecklist() {
    const task = this.props.tasks.find(
      (task) => task.id === this.props.currentTask.id
    );

    const selectedStatus = [];
    if (task !== undefined) {
      TasksChecklist.keys.forEach((key) => {
        if (
          task.task_checklist !== undefined &&
          task.task_checklist !== null &&
          task.task_checklist[key]
        ) {
          selectedStatus.push(key);
        }
      });
    }

    if (this.props.currentTask.status === TaskStatusKeys.PRE) {
      if (this.userIsContractor()) {
        return (
          <div className="task-checklist-container">
            <div className="h3">Checklist</div>
            <TasksChecklist
              readOnly={false}
              selectedStatus={selectedStatus}
              showForContractor={this.userIsContractor()}
              onSelect={this.handleTaskChecklistSelect}
            />
          </div>
        );
      } else {
        return (
          <div className="task-checklist-container">
            <div className="h3">Checklist</div>
            <TasksChecklist
              readOnly={true}
              selectedStatus={selectedStatus}
              showForContractor={this.userIsContractor()}
            />
          </div>
        );
      }
    } else if (this.props.currentTask.status === TaskStatusKeys.WIP) {
      return (
        <div className="task-checklist-container">
          <div className="h3">Checklist</div>
          <TasksChecklist
            readOnly={true}
            selectedStatus={selectedStatus}
            showForContractor={this.userIsContractor()}
          />
        </div>
      );
    } else {
      return null;
    }
  }

  handleTaskChange = (taskId, attribute, value, label) => {
    this.props.dispatch(taskChangeRequest(taskId, attribute, value, label));
    if (attribute === 'trade') {
      this.props.dispatch(loadSubTradesRequest(value));
    }
  };

  handleTaskEdit = () => {
    this.props.dispatch(editTask());
  };

  handleTaskDelete = () => {
    this.setState({
      showDeleteConfirmation: true,
    });
  };

  handleTaskCancel = () => {
    this.props.dispatch(cancelTask(this.props.currentWorkOrder.id));
  };

  handleTaskSubmit = () => {
    this.props.dispatch(
      updateTaskRequest(this.props.currentWorkOrder.id, this.props.currentTask)
    );
  };

  handleBidsRequest = () => {
    this.props.dispatch(
      showQuotesRequestModalRequest(
        this.props.currentWorkOrder.propietary_sub_contractors,
        [this.props.currentTask.trade]
      )
    );
  };

  handleCreateQuote = () => {
    this.props.dispatch(showCreateQuoteModal());
  };

  handleDenyQuote = () => {
    this.props.dispatch(showDenyQuoteModal());
  };

  handleStartTask = () => {
    this.props.dispatch(startTask(this.props.currentTask.id));
  };

  handleCompleteTask = () => {
    this.props
      .dispatch(completeTask(this.props.currentTask.id))
      .then((result) => {
        if (result.ok) {
          // Show confirmation modal
          this.setState({
            showCompleteModal: true,
          });

          // Check if all tasks are "cmp", and if true, mark WO as "complete" (locally)
          if (
            this.props.tasks.filter((task) => task.status !== 'cmp').length ===
            0
          ) {
            this.props.dispatch(markCurrentWorkOrderAsComplete());
          }
        }
      });
  };

  handleApproveWork = () => {
    this.props
      .dispatch(approveTaskWorkRequest(this.props.currentTask.id))
      .then((response) => {
        if (response.ok) {
          this.setState({
            showApprovedModal: true,
          });
        }
      });
  };

  handleCloseApprovedModal = () => {
    this.setState({
      showApprovedModal: false,
    });
    this.props.dispatch(goToWorkOrder(this.props.currentWorkOrder.id));
  };

  handleViewCounterQuote = () => {
    this.handleResubmitQuote();
  };

  handleResubmitQuote = () => {
    const taskQuote = this.findQuoteForCurrentTask();
    if (taskQuote !== null) {
      this.props.dispatch(showReviewQuoteModal(taskQuote));
    }
  };

  handleTaskImageRemove = (index) => {
    this.props.dispatch(removeImageRequest(this.props.currentTask, index));
  };

  handleLoadNotes = () => {
    return this.props.dispatch(loadTaskNotesRequest(this.props.currentTask.id));
  };

  handleAddNote = (text) => {
    return this.props.dispatch(
      addTaskNoteRequest(this.props.currentTask.id, text)
    );
  };

  handleNotesClick = () => {
    simpleScrollTo('task-notes-container');
  };

  handleAddOpenItem = () => {
    this.props.dispatch(
      setShowAddOpenItemModalRequest(this.props.currentTask.id)
    );
  };

  handleSelectOpenItem = (openItemId) => {
    const openItem = this.props.openItemsByTaskId[
      this.props.currentTask.id
    ].find((openItem) => openItem.id === openItemId);
    this.props.dispatch(setSelectedOpenItem(openItem));
  };

  handleDeleteCo = () => {
    this.setState({
      showDeleteCoConfirmation: true,
    });
  };

  handleWithdrawQuote = () => {
    this.setState({
      showWithdrawConfirmation: true,
    });
  };

  handleWithdrawCoQuote = () => {
    this.setState({
      showWithdrawCoQuoteConfirmation: true,
    });
  };

  handleWithdrawCoQuoteRequest = () => {
    this.setState({
      showWithdrawCoQuoteRequestConfirmation: true,
    });
  };

  handleDeleteCoConfirmation = (result) => {
    if (result) {
      this.props.dispatch(deleteChangeOrderTask(this.changeOrderTask.id));
    }
    this.setState({
      showDeleteCoConfirmation: false,
    });
  };

  handleWithdrawConfirmation = (result) => {
    if (result) {
      const taskQuote = this.findQuoteForCurrentTask();
      if (taskQuote !== null) {
        this.props.dispatch(withdrawQuoteRequest(taskQuote.id)); // only one quote for current task
      }
    }
    this.setState({
      showWithdrawConfirmation: false,
    });
  };

  handleWithdrawCoQuoteConfirmation = (result) => {
    if (result) {
      this.props.dispatch(withdrawChangeOrderQuote(this.changeOrderTask.id));
    }
    this.setState({
      showWithdrawCoQuoteConfirmation: false,
    });
  };

  handleWithdrawCoQuoteRequestConfirmation = (result) => {
    if (result) {
      this.props.dispatch(
        withdrawChangeOrderQuoteRequest(this.changeOrderTask.id)
      );
    }
    this.setState({
      showWithdrawCoQuoteRequestConfirmation: false,
    });
  };

  handleDeleteConfirmation = (result) => {
    if (result) {
      this.props
        .dispatch(deleteTaskRequest(this.props.currentTask.id))
        .then((response) => {
          if (response.ok) {
            this.props.dispatch(goToWorkOrder(this.props.currentWorkOrder.id));
          }
        });
    }
    this.setState({
      showDeleteConfirmation: false,
    });
  };

  handleTaskChecklistSelect = (itemId) => {
    const task = this.props.tasks.find(
      (task) => task.id === this.props.currentTask.id
    );
    if (task !== undefined) {
      const value = !task.task_checklist[itemId];
      this.props.dispatch(
        markItemTaskChecklistRequest(
          this.props.currentTask.id,
          task.task_checklist.id,
          itemId,
          value
        )
      );
    }
  };

  handleCompleteTaskImageUpload = (taskChecklistId, images) => {
    this.props.dispatch(
      uploadCompleteTaskImagesRequest(taskChecklistId, images)
    );
  };

  handleCompleteTaskImageRemove = (images, taskChecklistId, imageIndex) => {
    this.props.dispatch(
      removeCompleteTaskImagesRequest(taskChecklistId, images[imageIndex].id)
    );
  };

  findQuoteForCurrentTask() {
    if (this.props.currentTask !== null) {
      const taskQuote = this.props.quotes.find(
        (quote) =>
          quote.task.id === this.props.currentTask.id &&
          (!this.userIsAdmin || !quote.contractor_id)
      );
      if (taskQuote !== undefined) {
        return taskQuote;
      }
    }
    return null;
  }
}

export default connect((state) => {
  return {
    currentWorkOrder: getCurrentWorkOrder(state),
    currentTask: getCurrentTask(state),
    editTask: getEditTask(state),
    openItemsByTaskId: getOpenItemsByTaskId(state),
    preExistingConditions: getPreExistingConditions(state),
    proposals: getProposals(state),
    quotes: getQuotes(state),
    quotesSelectedByTaskId: getQuotesSelectedByTaskId(state),
    selectedOpenItemId: getSelectedOpenItemId(state),
    subTradesByTradeId: getSubTradesByTradeId(state),
    taskNotes: getTaskNotes(state),
    tasks: getTasks(state),
    trades: getTrades(state),
    user: state.auth.user,
    changeOrderTasks: getChangeOrderTasks(state),
  };
})(DetailsTasks);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/DetailsTasks.js